import React from 'react'
import ExpenseForm from './ExpenseForm'
import './ExpenseFrom.css'


const NewExpenses = (props) => {
  const SaveExpenseDataHandler = (expenseData) => {
   const data = {
    ...expenseData,
    id: (Math.random()*100),
   }
     props.onGetExpenseData(data)  
  }
  
  
  return (
    <ExpenseForm onSaveExpenseData={SaveExpenseDataHandler}/>
  )
}

export default NewExpenses 